// RefundPolicyModal.js
import React from "react";
import styled from "styled-components";

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 80%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
`;

const ConfirmButton = styled.button`
  background-color: #2195f3;
  color: white;
  border: none;
  padding: 9px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-family: Pretendard, sans-serif;
  font-size: 15px;
  margin-top: 19px;
`;

const RefundPolicyContent = styled.div`
  text-align: left;
  font-family: Pretendard, sans-serif;
  font-size: 13px;
  line-height: 1.2;

  h1,
  h3 {
    margin-top: 19px;
    margin-bottom: 9px;
  }

  p {
    margin-bottom: 9px;
  }

  ul,
  ol {
    margin-top: 10px;
    padding-left: 20px;

    li {
      margin-bottom: 10px;
    }
  }

  table {
    border-collapse: collapse;
    width: 99%;
    margin-bottom: 9px;
  }

  th,
  td {
    border: 0px solid #ddd;
    padding: 7px;
    text-align: left;
  }

  th {
    background-color: #f1f2f2;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }
`;
const RefundPolicyModal = ({ isOpen, onClose }) => {
  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;

  return (
    <Modal onClick={onClose}>
      <ModalContent onClick={handleModalClick}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <RefundPolicyContent>
          <h2>AlphaNote 환불 정책</h2>
          <p>환불정책 시행일: 2024-10-08</p>
          <h3>1. 구독 플랜 환불 정책</h3>
          <p>
            AlphaNote 구독 플랜(7일 플랜, 30일 플랜, 365일 플랜)의 환불은 다음과
            같이 진행됩니다.
          </p>
          <p>
            ■ 구독 기간이란 회사가 회원에게 유상으로 제공하는 서비스 이용기간을
            의미합니다. (7일 플랜: 7일, 30일 플랜: 30일, 365일 플랜: 365일)
          </p>
          <p>
            ■ 구독 기간은 결제일부터 시작합니다. 단, 결제일 당시 서비스를 이용할
            수 없는 경우 서비스의 이용 가능일부터 시작합니다.
          </p>
          <p>
            ■ 서비스 이용이란 AlphaNote 서비스에 접속하여 매매일지, 분석 리포트
            등을 확인하거나 다운로드하는 행위를 의미합니다.
          </p>
          <p>
            <strong>환불 금액 산정 기준:</strong>
          </p>
          <ul>
            <li>
              구독 기간 시작일로부터 7일 이내에 서비스를 전혀 이용하지 않은
              경우: 결제대금 전액 환불
            </li>
            <li>
              그 외의 경우: 일일 단가를 우선적으로 차감한 차액을 환불
              <br />
              <strong>
                ※ 일일 단가는 할인 전 정상가 기준으로 계산됩니다.
              </strong>
              <br />
              (정상가 일일 단가: 714원/일)
              <br />
              환불 금액 = 결제 금액 - (이용한 일수 × 714원)
            </li>
            <li>
              환불 금액이 0원 이하인 경우 환불이 불가능합니다.
            </li>
          </ul>
          <p>
            <strong>정상가 기준:</strong>
          </p>
          <ul>
            <li>7일 플랜: 5,000원 (정상가)</li>
            <li>30일 플랜: 21,429원 (정상가) → 20,000원 (할인가)</li>
            <li>365일 플랜: 260,714원 (정상가) → 200,000원 (할인가)</li>
          </ul>
          <h4>환불 금액 계산 예시:</h4>
          <ul>
            <li>
              7일 플랜(5,000원, 정상가) 구매 후 2일 사용 후 환불 요청 시
              <br />
              이용 금액: 2일 × 714원 = 1,428원
              <br />
              환불 금액: 5,000원 - 1,428원 = 3,572원
            </li>
            <li>
              30일 플랜(20,000원, 할인가) 구매 후 10일 사용 후 환불 요청 시
              <br />
              이용 금액: 10일 × 714원 = 7,140원
              <br />
              환불 금액: 20,000원 - 7,140원 = 12,860원
              <br />
              <strong>
                ※ 일일 단가는 할인 전 정상가(714원/일) 기준으로 차감됩니다.
              </strong>
            </li>
            <li>
              365일 플랜(200,000원, 할인가) 구매 후 30일 사용 후 환불 요청 시
              <br />
              이용 금액: 30일 × 714원 = 21,420원
              <br />
              환불 금액: 200,000원 - 21,420원 = 178,580원
            </li>
            <li>
              365일 플랜(200,000원, 할인가) 구매 후 300일 사용 후 환불 요청 시
              <br />
              이용 금액: 300일 × 714원 = 214,200원
              <br />
              환불 금액: 200,000원 - 214,200원 = -14,200원
              <br />
              <strong>
                ※ 환불 금액이 0원 이하이므로 환불이 불가능합니다.
              </strong>
            </li>
          </ul>
          <h3>2. 기타 사항</h3>
          <p>
            ■ 회사가 마케팅, 이벤트 등과 관련하여 무상으로 부여하는 추가
            이용기간(보너스기간)은 환불에 영향을 미치지 아니합니다.
          </p>
          <p>
            ■ 회사는 환불 시 금융거래수수료, 제세공과금 등을 공제할 수 있습니다.
          </p>
          <p>
            ■ 회사는 회원이 관계 법령 또는 이용약관 등을 위반한 경우 이용약관 및
            정책에 따라 환불을 거부할 수 있습니다.
          </p>
          <p>
            ■ 결합 상품의 경우 각 구성 상품(용역)의 환불 조건에 의하되 개별 상품
            안내페이지를 통하여 고지합니다.
          </p>
          <h3>3. 환불 제외 사항</h3>
          <p>다음의 경우에는 환불이 불가능합니다:</p>
          <ul>
            <li>서비스의 악용이 명백한 경우</li>
            <li>관계 법령 또는 이용약관 등을 위반한 경우</li>
            <li>
              그 밖에 이용약관 및 정책에서 정하는 환불 제외 사유에 해당하는 경우
            </li>
          </ul>
          <h3>4. 환불 절차</h3>
          <ol>
            <li>고객센터 이메일(contact@arpa.co.kr)로 환불 요청</li>
            <li>
              환불 요청 시 다음 자료 첨부:
              <ul>
                <li>이용자 본인 확인을 위한 신분증 사본(주민등록번호 제외)</li>
                <li>통장사본</li>
                <li>주소를 알 수 있는 자료</li>
              </ul>
            </li>
            <li>회사의 환불 사유 및 이용 내역 확인</li>
            <li>환불 금액 산정 및 승인</li>
            <li>승인 후 7일 이내 결제 수단으로 환불 처리</li>
          </ol>
          <h3>5. 정책의 개정</h3>
          <p>
            ■ 회사는 「약관의 규제에 관한 법률」, 「전자상거래 등에서의
            소비자보호에 관한 법률」 등 관계 법령을 위배하지 아니하는 범위
            내에서 이 정책을 개정할 수 있습니다.
          </p>
          <p>
            ■ 회사가 이 정책을 개정하는 경우 회원에게 주요 개정내용과 시행일
            등을 명시하여 시행일로부터 7일 전에 전자적 방법으로
            알려드리겠습니다. 다만, 회원에게 불리한 내용이 포함되는 경우
            시행일로부터 30일 전에 알려드리겠습니다.
          </p>
          <p>
            AlphaNote 서비스와 관련하여 궁금하신 사항이 있으시면
            고객센터(대표번호: 010-2605-2193 / 평일 10:00~17:00)로 문의 주시기
            바랍니다.
          </p>
        </RefundPolicyContent>
        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </ModalContent>
    </Modal>
  );
};

export default RefundPolicyModal;
